import { render, staticRenderFns } from "./MsgElementVideo.vue?vue&type=template&id=5722dd16&scoped=true"
import script from "./MsgElementVideo.vue?vue&type=script&lang=js"
export * from "./MsgElementVideo.vue?vue&type=script&lang=js"
import style0 from "./MsgElementVideo.vue?vue&type=style&index=0&id=5722dd16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722dd16",
  null
  
)

export default component.exports